import { AccountSurveyAction } from '@app/store/account/survey/actions';
import {
  ACCOUNT_SURVEY_UPDATE_FAILURE,
  ACCOUNT_SURVEY_UPDATE_REQUEST,
  ACCOUNT_SURVEY_UPDATE_SUCCESS,
} from '@app/store/actionTypes';

type AccountSurveyState = boolean;

const initialState: AccountSurveyState = false;

export default function reducer(
  state: AccountSurveyState = initialState,
  action: AccountSurveyAction
) {
  switch (action.type) {
    case ACCOUNT_SURVEY_UPDATE_REQUEST:
      return true;
    case ACCOUNT_SURVEY_UPDATE_SUCCESS:
    case ACCOUNT_SURVEY_UPDATE_FAILURE:
      return false;
    default:
      return state;
  }
}
